//@ts-ignore
//eslint-disable-next-line
export default function auth({ to, from, next, store, i18n }) {
  if (store.getters["auth/isLogged"]) {
    if (store.getters["auth/resetPassword"] && to.name != "ResetearPassword") {
      next({
        name: "ResetearPassword",
        params: { lang: i18n.locale },
        replace: true,
      });
    } else {
      next();
    }
  } else {
    next({
      name: "Login",
      params: { lang: i18n.locale },
      replace: true,
    });
  }
}
